import React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import {
  CssDataJacketButton,
  CssDataJacketTitleTypography,
} from "../../styles/styled";

import {
  StoreInDataNetwork,
  StoreInUpdateDataNetwork,
  saveDataNetwork,
  getMyConnectDJId,
  getMyConnectDj,
} from "../../js/queriesHandling";

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#505458",
      sub: grey[50],
      light: grey[50],
      dark: grey[900],
      constrastText: grey[50],
    },
    secondary: {
      main: "#75787b",
    },
  },
});
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const CssTypography = styled(Typography)({
  color: "white",
});

const CssButton = styled(Button)({
  backgroundColor: "grey",
});

export function SendToMyConnectDj({
  open,
  setOpenRegister,
  setAnswerYes,
  setName,
  setSummary,
  name,
  summary,
  myRef,
  user,
  networkData,
  setNodePosition1,
  foldNode,
  setNetworkData,
  saveImage,
  setSavedId,
  savedId,
  setAnswerNo,
  connectId,
  visibleEdgeTypes,
  networkDataStorage,
  continuousSaving,
  setContinuousSaving,
}) {
  const [invalid, setInvalid] = React.useState("");
  const [defaultName, setDefaultName] = React.useState(name);
  const [defaultSummary, setDefaultSummary] = React.useState(summary);
  const [overwriteModalOpen, setOverwriteModalOpen] = React.useState(false);

  async function handleSave() {
    const matchedConnectDjId = await getMyConnectDJId(user, name);
    // 既にMYDATAに登録されている名称を上書き処理で使用する為
    const registeredMyConnectDjItem = await getMyConnectDj(matchedConnectDjId);
    const registeredMyConnectDjName = registeredMyConnectDjItem.connect_dj_name;
    myRef.current.elements("node").lock();
    if (connectId !== "") {
      // 既に登録されているIDと編集しているもののIDが一致するかどうか判定
      //　一致した時　そのまま同じIDに対して更新をかける
      if (
        user !== undefined &&
        user != "" &&
        networkData.length > 0 &&
        matchedConnectDjId === connectId
      ) {
        const id = await StoreInUpdateDataNetwork(
          connectId,
          saveImage,
          name,
          summary,
          JSON.stringify({
            networkData: setNodePosition1(networkData),
            foldData: foldNode,
          }),
          JSON.stringify(visibleEdgeTypes),
          JSON.stringify(networkDataStorage)
        );
        setSavedId(id);
        // 一致していない場合
      } else {
        if (matchedConnectDjId === "") {
          const id = await StoreInDataNetwork(
            user,
            saveImage,
            name,
            summary,
            JSON.stringify({
              networkData: setNodePosition1(networkData),
              foldData: foldNode,
            }),
            JSON.stringify(visibleEdgeTypes),
            JSON.stringify(networkDataStorage)
          );
          setSavedId(id);
        } else {
          const id = await StoreInUpdateDataNetwork(
            matchedConnectDjId,
            saveImage,
            registeredMyConnectDjName, // ここにMYDATAに登録済みの名称を入れる
            summary,
            JSON.stringify({
              networkData: setNodePosition1(networkData),
              foldData: foldNode,
            }),
            JSON.stringify(visibleEdgeTypes),
            JSON.stringify(networkDataStorage)
          );
          setSavedId(id);
        }
      }
    } else if (savedId === "") {
      // CONNECT DJ画面から作成時
      // 入力内容と同じ名称をもつコネクトDJのIDが存在しない
      setContinuousSaving(true);
      if (
        user !== undefined &&
        user != "" &&
        networkData.length > 0 &&
        matchedConnectDjId === ""
      ) {
        const id = await StoreInDataNetwork(
          user,
          saveImage,
          name,
          summary,
          JSON.stringify({
            networkData: setNodePosition1(networkData),
            foldData: foldNode,
          }),
          JSON.stringify(visibleEdgeTypes),
          JSON.stringify(setNodePosition1(networkDataStorage))
        );
        setSavedId(id);
        // 入力内容と同じ名称をもつコネクトDJのIDが存在している
      } else if (
        user !== undefined &&
        user != "" &&
        networkData.length > 0 &&
        matchedConnectDjId !== ""
      ) {
        // ここで既に登録されているIDと現在編集しているコネクトDJのIDが一致しているか判定
        // 一致した時
        if (matchedConnectDjId === connectId) {
          // 一致した場合　モーダル無しで上書き
          // 新規作成時に名称被りで上書き保存するロジック
          const id = await StoreInUpdateDataNetwork(
            matchedConnectDjId,
            saveImage,
            registeredMyConnectDjName,
            summary,
            JSON.stringify({
              networkData: setNodePosition1(networkData),
              foldData: foldNode,
            }),
            JSON.stringify(visibleEdgeTypes),
            JSON.stringify(setNodePosition1(networkDataStorage))
          );
          setSavedId(id);
        }
        // 不一致の場合　入力した名称と同じ名称を持つコネクトDJのIDに対して上書き
        // モーダルあり
        else if (matchedConnectDjId !== connectId) {
          const id = await StoreInUpdateDataNetwork(
            matchedConnectDjId,
            saveImage,
            registeredMyConnectDjName,
            summary,
            JSON.stringify({
              networkData: setNodePosition1(networkData),
              foldData: foldNode,
            }),
            JSON.stringify(visibleEdgeTypes),
            JSON.stringify(setNodePosition1(networkDataStorage))
          );
          setSavedId(id);
        }
      }
    } else {
      // 一回保存した後に再度保存する時
      setContinuousSaving(true);
      if (
        user !== undefined &&
        user != "" &&
        networkData.length > 0 &&
        matchedConnectDjId === ""
      ) {
        const id = await StoreInDataNetwork(
          user,
          saveImage,
          name,
          summary,
          JSON.stringify({
            networkData: setNodePosition1(networkData),
            foldData: foldNode,
          }),
          JSON.stringify(visibleEdgeTypes),
          JSON.stringify(networkDataStorage)
        );
        setSavedId(id);
      } else if (
        user !== undefined &&
        user != "" &&
        networkData.length > 0 &&
        matchedConnectDjId !== ""
      ) {
        // ここで既に登録されているIDと現在編集しているコネクトDJのIDが一致しているか判定
        // 一致した時
        if (matchedConnectDjId === connectId) {
          // 一致した場合　モーダル無しで上書き
          // 新規作成時に名称被りで上書き保存するロジック
          const id = await StoreInUpdateDataNetwork(
            matchedConnectDjId,
            saveImage,
            name,
            summary,
            JSON.stringify({
              networkData: setNodePosition1(networkData),
              foldData: foldNode,
            }),
            JSON.stringify(visibleEdgeTypes),
            JSON.stringify(setNodePosition1(networkDataStorage))
          );
          setSavedId(id);
        }
        // 不一致の場合　入力した名称と同じ名称を持つコネクトDJのIDに対して上書き
        // モーダルあり
        else if (matchedConnectDjId !== connectId) {
          const id = await StoreInUpdateDataNetwork(
            matchedConnectDjId,
            saveImage,
            registeredMyConnectDjName,
            summary,
            JSON.stringify({
              networkData: setNodePosition1(networkData),
              foldData: foldNode,
            }),
            JSON.stringify(visibleEdgeTypes),
            JSON.stringify(setNodePosition1(networkDataStorage))
          );
          setSavedId(id);
        }
      }
    }
  }

  async function handleSaveTemp() {
    // 一時保存する際に使用している
    //新規登録する時とMYDATAから登録する時で処理を分ける必要がある
    let saveNetworkName = "temp"; // Can be change from temp to custom name
    let saveCommand = "temp"; // Can be change from temp to new or edit
    myRef.current.elements("node").lock();

    if (user !== undefined && user != "" && networkData.length > 0) {
      await saveDataNetwork(
        user,
        saveNetworkName,
        "",
        saveCommand,
        JSON.stringify({
          networkData: setNodePosition1(networkData),
          foldData: foldNode,
        })
      );
    }
  }

  async function handleYes() {
    const matchedConnectDjId = await getMyConnectDJId(user, name); // nameは画面で入力している名称

    if (name == "") {
      setInvalid("名称が空白になっています");
    } else if (name.length > 200) {
      setInvalid("名称を200文字以内にしてください");
    } else if (summary.length > 1000) {
      setInvalid("説明文を1000文字以内にしてください");
    } else if (matchedConnectDjId !== "" && name !== defaultName) {
      setOverwriteModalOpen(true);
    } else {
      await handleSave();
      setNetworkData([]);
      myRef.current.stop();
      myRef.current.destroy();
      setAnswerYes(false);
      setOpenRegister(false);
    }
  }
  async function handleNo() {
    await handleSaveTemp();
    setNetworkData([]);
    myRef.current.stop();
    myRef.current.destroy();
    setAnswerNo(false);
    setOpenRegister(false);
    nameAndSummaryEdit();
  }

  // 名称が重複した際の確認モーダルで「はい」クリックした時
  async function handleOverwriteYes() {
    setOverwriteModalOpen(false);
    await handleSave();
    setNetworkData([]);
    myRef.current.stop();
    myRef.current.destroy();
    setAnswerYes(false);
    setOpenRegister(false);
  }

  // 名称が重複した際の確認モーダルで「いいえ」クリックした時
  async function handleOverwriteNo() {
    setOverwriteModalOpen(false);
  }

  function nameAndSummaryEdit() {
    if (continuousSaving === false && connectId) {
      setName(defaultName);
      setSummary(defaultSummary);
    } else if (continuousSaving === true) {
      setName(defaultName);
      setSummary(defaultSummary);
    } else {
      setName("");
      setSummary("");
    }
  }

  return (
    <>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ThemeProvider theme={customTheme}>
          <Box
            sx={{
              position: "relative",
            }}
          >
            <Box
              style={{ color: "white" }}
              sx={{
                border: "solid 1px #666666",
                position: "relative",
                backgroundColor: "#303234",
                width: "80%",
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                marginTop: "100px",
              }}
            >
              <Box style={{ height: "50px", backgroundColor: "#373737" }}>
                <Stack direction="row" spacing={2}>
                  <Item>
                    <CssDataJacketTitleTypography
                      style={{ marginLeft: "32px" }}
                    >
                      メッセージ
                    </CssDataJacketTitleTypography>
                  </Item>
                </Stack>
              </Box>
              <CssTypography
                id="child-modal-description"
                style={{ margin: "20px 20px" }}
              >
                {"以下の内容で登録します"}
              </CssTypography>
              <FormControl
                style={{
                  width: "95%",
                  margin: "0 auto",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <CssTypography style={{ width: "20%", textAlign: "center" }}>
                    {"CONNECT DJ名称:"}
                  </CssTypography>
                  <TextField
                    style={{
                      flex: 1,
                      border: "1px solid white",
                      backgroundColor: "rgba(255, 255, 255, 0.25)",
                      width: "80%",
                    }}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    defaultValue={
                      continuousSaving === true
                        ? connectId !== ""
                          ? defaultName
                          : defaultName
                        : connectId !== ""
                        ? defaultName
                        : ""
                    }
                    onChange={(e) => setName(e.target.value)}
                    variant="outlined"
                    inputProps={{
                      style: {
                        color: "white",
                      },
                    }}
                  />
                </Box>
                <Box
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <CssTypography style={{ width: "20%", textAlign: "center" }}>
                    {"CONNECT DJ説明文:"}
                  </CssTypography>
                  <TextField
                    variant="outlined"
                    multiline
                    rows={4}
                    style={{
                      flex: 1,
                      marginTop: "10px",
                      border: "1px solid white",
                      backgroundColor: "rgba(255, 255, 255, 0.25)",
                      width: "80%",
                    }}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    defaultValue={
                      continuousSaving === true
                        ? connectId !== ""
                          ? defaultSummary
                          : defaultSummary
                        : connectId !== ""
                        ? defaultSummary
                        : ""
                    }
                    onChange={(e) => setSummary(e.target.value)}
                    inputProps={{
                      style: {
                        color: "white",
                      },
                    }}
                  />
                </Box>
                <Box
                  style={{
                    color: "red",
                    width: "80%",
                    margin: "0 0 0 auto",
                  }}
                >
                  {invalid}
                </Box>
              </FormControl>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
                <CssDataJacketButton
                  onClick={handleYes}
                  style={{
                    width: "100px",
                    height: "35px",
                  }}
                >
                  はい
                </CssDataJacketButton>
                <Box sx={{ marginRight: 2 }}></Box>
                <CssButton
                  onClick={handleNo}
                  style={{
                    width: "100px",
                    color: "white",
                    height: "35px",
                    border: "2px solid white",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  いいえ
                </CssButton>
              </Box>
            </Box>
          </Box>
        </ThemeProvider>
      </Modal>

      {/* 上書き確認のメッセージを表示させる */}

      <Modal
        open={overwriteModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "relative",
            zIndex: "200",
          }}
        >
          <Box
            style={{ color: "white" }}
            sx={{
              border: "solid 1px #666666",
              position: "relative",
              backgroundColor: "#303234",
              width: "40%",
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              marginTop: "100px",
            }}
          >
            <Box style={{ height: "50px", backgroundColor: "#373737" }}>
              <Stack direction="row" spacing={2}>
                <Item>
                  <CssDataJacketTitleTypography style={{ marginLeft: "32px" }}>
                    メッセージ
                  </CssDataJacketTitleTypography>
                </Item>
              </Stack>
            </Box>
            <CssTypography
              id="child-modal-description"
              style={{ margin: "20px 20px" }}
            >
              <>
                同じ名称のCONNECT DJが既に登録されています。
                <br />
                上書きしてもよろしいですか？
              </>
            </CssTypography>
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "20px",
              }}
            >
              <CssDataJacketButton
                onClick={handleOverwriteYes}
                style={{ width: "100px", height: "35px" }}
              >
                はい
              </CssDataJacketButton>
              <Box sx={{ marginRight: 2 }}></Box> {/* 16px の間隔 */}
              <CssButton
                onClick={handleOverwriteNo}
                style={{
                  width: "100px",
                  color: "white",
                  height: "35px",
                  border: "2px solid white",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                いいえ
              </CssButton>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
